module.exports = __webpack_public_path__ + "static/img/HK-Windows.7a5033d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HK-Windows.png
// module id = k0Lm
// module chunks = 1